export const omOsItems = [
    {
        id: 1,
        title: "HVEM ER VI",
        path: "./HvemErVi",
        cName: "SupLink"
    },
    {
        id: 2,
        title: "LEDELSE OG ANSATTE",
        path: "./LedelseAnsatte",
        cName: "SupLink"
    },
    {
        id: 3,
        title: "DET VI TROR PÅ",
        path: "./DetViTrorPaa",
        cName: "SupLink"
    },
    {   
        id: 4,
        title: "INTERNATIONAL MISSION",
        path: "./LedelseAnsatte#udsendte",
        cName: "SupLink"
    }
]